module.exports = __webpack_public_path__ + "img/cruz.af726b1f.webp";